import { render, staticRenderFns } from "./UserSettingsContactCreate.vue?vue&type=template&id=00fa8410&scoped=true&"
import script from "./UserSettingsContactCreate.vue?vue&type=script&lang=js&"
export * from "./UserSettingsContactCreate.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsContactCreate.vue?vue&type=style&index=0&id=00fa8410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa8410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fa8410')) {
      api.createRecord('00fa8410', component.options)
    } else {
      api.reload('00fa8410', component.options)
    }
    module.hot.accept("./UserSettingsContactCreate.vue?vue&type=template&id=00fa8410&scoped=true&", function () {
      api.rerender('00fa8410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/UserSettings/UserSettingsContact/UserSettingsContactCreate.vue"
export default component.exports